import {makeStyles, Menu, MenuItem} from "@material-ui/core";
import {useCallback, useRef, useState} from "react";

const useStyles = makeStyles(() => ({
  dotIcon: {
    width: 20,
    height: 20,
    cursor: 'pointer',
    verticalAlign:'middle'
  },
  menuItem: {
    padding: 0
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 30,
    marginLeft: 30,
    width: '100%'
  }
}));

interface IProps {
  onAddTags: () => void
  onRemoveTags: () => void
  onRemoveParticipant: () => void
}

function ParticipantDotMenu(props: IProps) {
  const classes = useStyles();
  const { onAddTags, onRemoveTags, onRemoveParticipant } = props;
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const onClickMenuItem = (index: number) => {
    handleMenuClose();
    switch (index) {
      case 0:
        onAddTags();
        return;
      case 1:
        onRemoveTags();
        return;
      case 2:
        onRemoveParticipant();
        return;
    }
  };

  const isEditable = useCallback(() => {
    const editable = localStorage.getItem('listEditable') ? localStorage.getItem('listEditable') : '';
    return editable === 'true';
  }, [localStorage]);

  return (
    <div>
      <img
        src={'/assets/icons/participant/list-table-dot.svg'}
        alt='dot menu'
        className={classes.dotIcon}
        ref={anchorRef}
        onClick={handleMenuOpen}
      />
      <Menu
        anchorEl={anchorRef.current}
        onClose={handleMenuClose}
        open={openMenu}
        PaperProps={{
          style: {width: 'auto', marginTop: 50, borderRadius: 12, marginLeft: -5}
        }}
      >
        {isEditable() ? (
          ['Add Tags', 'Remove Tags', 'Remove Participant'].map((option, index) => (
            <MenuItem
              className={classes.menuItem}
              id='tag_handling_button'
              key={option}
              onClick={() => onClickMenuItem(index)}
            >
              <p className={classes.btn}>{option}</p>
            </MenuItem>
          ))
        ) : (
          ['Add Tags', 'Remove Tags'].map((option, index) => (
            <MenuItem
              className={classes.menuItem}
              id='tag_handling_button_2'
              key={option}
              onClick={() => onClickMenuItem(index)}
            >
              <p className={classes.btn}>{option}</p>
            </MenuItem>
          ))
        )}
      </Menu>
    </div>
  )
}

export default ParticipantDotMenu;